import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "p-6 mt-4 rounded-md shadow-md bg-white cursor-pointer" }
const _hoisted_2 = {
  key: 0,
  class: "select-text text-justify mt-2"
}

import { ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  props: {
    title: null
  },
  setup(__props: any) {

const props = __props as {
  title: string;
}


const showContent = ref(false);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", {
      class: "text-xl font-semibold text-curaduriaDark select-none hover:text-indigo-600",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (showContent.value = !showContent.value))
    }, _toDisplayString(props.title), 1),
    _createVNode(_Transition, {
      "enter-active-class": "duration-200 ease-out",
      "enter-from-class": "opacity-0 scale-95",
      "enter-to-class": "opacity-100 scale-100",
      "leave-active-class": "duration-100 ease-in",
      "leave-from-class": "opacity-100 scale-100",
      "leave-to-class": "opacity-0 scale-95"
    }, {
      default: _withCtx(() => [
        (showContent.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _renderSlot(_ctx.$slots, "default")
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 3
    })
  ]))
}
}

})